import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';

import InputField from 'components/LoginForm/Input';
// TODO add password fields
// TO CHECK: Las Vegas (Firebase login)
const Register = props => (
  <div className="Register">
    <h3>
      {i18n.translate('loginScreen.newUser')}
    </h3>

    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="email"
      fieldName="reg_email"
      fieldPlaceholder={i18n.translate('loginScreen.fields.email')}
      icon="at"
      focus
      line
    />

    {props.passwordField && <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_password"
      fieldPlaceholder={i18n.translate('loginScreen.fields.password')}
      icon="key"
      line
    />
    }

    {props.passwordField && <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_passwordConfirm"
      fieldPlaceholder={i18n.translate('loginScreen.fields.passwordConfirm')}
      icon="key"
      line
    />
    }

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_first_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.firstName')}
      icon="user"
      line
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_last_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.lastName')}
      icon="user"
      line
    />

    <h3>{i18n.translate('loginScreen.fields.agencyName')}</h3>

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_agency_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.agencyName')}
      icon="building"
      line
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_state"
      fieldPlaceholder={i18n.translate('loginScreen.fields.stateProvince')}
      icon="map-marker"
      line
    />

    <div className="login__form--buttons">
      <Link to="/login">
        <button type="button" onClick={props.back} className="Email__input--button btnInverse">{i18n.translate('general.back')}</button>
      </Link>
      <button type="submit" onClick={props.submit} className="Email__input--button">
        {props.loadingAnimRegister ? <span><FontAwesomeIcon icon={['fas', 'circle-notch']} spin /></span> : i18n.translate('loginScreen.register')}
      </button>
    </div>
  </div>
);

export default Register;

Register.propTypes = {
  passwordField: PropTypes.bool,
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
};

Register.defaultProps = {
  defaultVal: '',
  passwordField: false,
};
